/**
 * ***********************************************************************************************************************
 * Responsibility - Displays the most basic details of an order. This includes the size, material, laminate, color, and
 * application. It only displays the three primary details by default but allows for 'Show all specs' to display all
 * details. 🐺
 * ***********
 *
 * @format
 */

import {
    PRODUCT_TYPE_GRAPHIC_DESIGN,
    PRODUCT_TYPE_CARTON,
    SUBSTRATE_BACKINGS,
    FORM_FACTOR_ROLLS
} from 'frontier-constants';
import React, {useState, useEffect} from 'react';
import {If, IfElse} from 'frontier-utilities';

//styles
import './order_basic_details.scss';

export const OrderBasicDetails = props => {
    const {order, isViewingAllSpecs, className, ...rest} = props;

    const [isOpen, setIsOpen] = useState(false);

    const sizeShape = order.size_label?.replace(/(W: |H: |L:|"|W:)/g, '');

    const application =
        order.form_factor_id !== FORM_FACTOR_ROLLS ? 'Hand-applied' : 'Machine-applied';
    const isDesign = order.product_type_id === PRODUCT_TYPE_GRAPHIC_DESIGN;
    const isMachineApplied = order.form_factor_id === FORM_FACTOR_ROLLS;
    const isCarton = order.product_type_id === PRODUCT_TYPE_CARTON;
    const isLabel = !isCarton && !isDesign;

    // other options
    const rollDiameter = order.roll_diameter_max
        ? `Max Roll Diameter: ${order.roll_diameter_max}`
        : '';
    const isHighOpacityBlack = order.is_high_opacity_black ? 'High Opacity Black' : '';
    const isHighOpacityWhite = order.is_high_opacity_white ? 'High Opacity White' : '';
    const isBlank = order.is_blank ? `Blank ${isCarton ? 'cartons' : 'labels'}` : '';
    const rollQty = order.roll_qty_max ? `Max Roll Qty: ${order.roll_qty_max}` : '';
    const isReversePrint = order.is_reverse_print ? 'Reverse Print' : '';
    const isDoubleSided = order.is_double_sided ? 'Double Sided' : '';
    const isDuplex = order.is_duplex ? 'Duplex' : '';
    const isEmbossing = order.is_embossing ? order.embossing_type_label : '';

    let allOptionsArray = [
        rollDiameter,
        isHighOpacityWhite,
        isHighOpacityBlack,
        isBlank,
        rollQty,
        isReversePrint,
        isDoubleSided,
        isDuplex,
        isEmbossing
    ];
    allOptionsArray = allOptionsArray.filter(option => option !== '');
    const allOptions = allOptionsArray.join(', ');

    useEffect(() => {
        setIsOpen(isViewingAllSpecs === true);
    }, [isViewingAllSpecs]);

    return (
        <div className={`oder-basic-details--label ${className}`} {...rest}>
            <If condition={isOpen}>
                <p>
                    <b>Total Qty: </b>
                    {order.duplex_aware_total_qty}
                </p>
            </If>
            <If condition={isOpen}>
                <p>
                    <b>Design Qty: </b>
                    {order.design_qty}
                </p>
            </If>
            <p>
                <b>Size/ Shape: </b>
                {sizeShape}
            </p>
            <p>
                <b>Material: </b>
                {order.substrate_label || 'N/A'}
            </p>
            <p>
                <b>Laminate: </b>
                {order.laminate_label || 'N/A'}
            </p>
            <If condition={isLabel}>
                <p>
                    <b>Backing: </b>
                    <IfElse condition={order.backing_label === ''}>
                        <span>Paper</span>
                        <span>{order.backing_label}</span>
                    </IfElse>
                </p>
            </If>
            <If condition={!isOpen}>
                <button
                    className="m-0 tw-p-0 bg-transparent d-flex align-items-center justify-content-start gap-2 color-accent-primary"
                    onClick={() => setIsOpen(!isOpen)}>
                    <i className="fa fa-plus" />
                    <u>Show all specs</u>
                </button>
            </If>
            <If condition={isOpen}>
                <If condition={isLabel}>
                    <p>
                        <b>Application: </b>
                        {application}
                    </p>
                </If>

                <If condition={isMachineApplied && isLabel}>
                    <p>
                        <b>Roll Direction: </b>
                        {order.roll_direction}
                    </p>
                </If>
                <p>
                    <b>Color: </b>
                    {order.color_label}
                </p>
                <If condition={allOptionsArray.length > 0}>
                    <p>
                        <b>Other Options: </b>
                        {allOptions}
                    </p>
                </If>
            </If>
            <If condition={isOpen}>
                <button
                    className="m-0 tw-p-0 bg-transparent d-flex align-items-center justify-content-start gap-2 color-accent-primary"
                    onClick={() => setIsOpen(!isOpen)}>
                    <i className="fa fa-minus" />
                    <u>Show less</u>
                </button>
            </If>
        </div>
    );
};
